module.exports = __webpack_public_path__ + "static/media/arrow.483cb90f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/Features/arrow.svg
// module id = 1019
// module chunks = 2